import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import BaseLayer from "../core/BaseLayer";
import GeometryModels from "./models";
export default class GeometryLayer extends BaseLayer {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "type", 'GeometryLayer');
    _defineProperty(this, "defaultSourceConfig", {
      data: [{
        x: 0,
        y: 0
      }],
      options: {
        parser: {
          type: 'json',
          x: 'x',
          y: 'y'
        }
      }
    });
  }
  buildModels() {
    var _this = this;
    return _asyncToGenerator(function* () {
      const modelType = _this.getModelType();
      _this.layerModel = new GeometryModels[modelType](_this);
      yield _this.initLayerModels();
    })();
  }
  getDefaultConfig() {
    const type = this.getModelType();
    const defaultConfig = {
      plane: {},
      sprite: {},
      billboard: {}
    };
    return defaultConfig[type];
  }
  getModelType() {
    var _shapeAttribute$scale;
    const shapeAttribute = this.styleAttributeService.getLayerStyleAttribute('shape');
    const shape = shapeAttribute === null || shapeAttribute === void 0 || (_shapeAttribute$scale = shapeAttribute.scale) === null || _shapeAttribute$scale === void 0 ? void 0 : _shapeAttribute$scale.field;
    if (shape === 'plane') {
      return 'plane';
    } else if (shape === 'sprite') {
      return 'sprite';
    } else if (shape === 'billboard') {
      return 'billboard';
    } else {
      return 'plane';
    }
  }
}